/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Minutes_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Minutes (MM)" |
*
* @param {Subtitle_Export_Minutes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_minutes_placeholder = /** @type {((inputs?: Subtitle_Export_Minutes_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Minutes_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minutes (MM)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Minuten (MM)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Minuti (MM)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минуты (мм)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Minutos (MM)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分钟（MM）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分（MM）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिनट (MM)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Minutos (MM)")
	return /** @type {LocalizedString} */ ("Minutes (MM)")
});